/**
 * Слайдер внутри слайдера для анимации с коробкой
 * (заморонженная продукция)
 */
export class Box {
    constructor(el) {
        this.container = el;
        this.screens = this.container.querySelectorAll('[data-box]');
        this.slidesLength = this.screens.length;

        this.indexActive = 0;
        this.indexOld = 0;
        this.indexNext = 1;
        this.indexPrev = -1;

        this.isFirst = true;
        this.isLast = false;
    }

    /**
     * Ограничиваем перемотку кол-вом слайдов
     */
    orderIndexes() {
        if (this.indexActive >= this.slidesLength) {
            this.indexActive = this.slidesLength - 1;
        }

        if (this.indexActive < 0) {
            this.indexActive = 0;
        }
    }

    /**
     * Переключаем
     */
    nextSlide() {
        this.indexOld = this.indexActive;
        this.indexActive++;
        this.orderIndexes();
        this.changeSlide();
    }

    prevSlide() {
        this.indexOld = this.indexActive;
        this.indexActive--;
        this.orderIndexes();
        this.changeSlide();
    }

    changeSlide() {
        if (this.indexActive == this.indexOld) { return; }

        // Подставляем класс активному слайду
        this.screens.forEach(screen => {
            if (+screen.getAttribute('data-box') === this.indexActive) {
                screen.classList.add('_is-visible');
            } else {
                screen.classList.remove('_is-visible');
            }
        });
    }

    /**
     * Определяем, находимся ли мы на первом или последнем кадре
     */
    isOnFirst() {
        return this.indexActive <= 0;
    }

    isOnLast() {
        return this.indexActive >= this.slidesLength - 1;
    }
}



// WEBPACK FOOTER //
// ./_src/js/Box.js